export interface InstanceType {
  id: number;
  instanceName: string;
  status: InstanceStatus;
  startDate: Date;
  domainName: string;
  numberOfInstances: number;
  backendDomainName: string;
}

export enum InstanceStatus {
  Running,
  Stopped,
}
